const EventCategory = {
    COMPANION:"EINV_COMPANION",
    INTRO: 'INTRO',
    HOME: 'HOME',
    MIS: 'MIS',
    QR_CODE: 'QR_CODE',
    INVOICES: 'INVOICES',
    ALERTS: 'ALERTS',
    SIDE_DRAW: 'SIDE_DRAW',
    BOTTOM_NAV_BAR: 'BOTTOM_NAV_BAR',
    BUSINESS_DRAW: 'BUSINESS_DRAW',
    LOGOUT_DRAW: 'LOGOUT_DRAW',
    FEEDBACK: 'FEEDBACK',
};

const EventActions = {
    CLICK : 'CLICK',
    PAGEVIEW : 'PAGEVIEW',
    VIEW : 'VIEW',
};

const EventLabels = {
    // intro page
    INTRO_PAGE: 'INTRO PAGE',
    SIGN_IN_CLICK : 'SIGN_IN',

    // home page
    HOME_PAGE:'HOME_PAGE',
    HOME_PAGE_TODAY : 'HOME_PAGE_TODAY',
    HOME_PAGE_LAST7 :'HOME_PAGE LAST 7 DAYS',
    HOME_PAGE_LAST30 :'HOME_PAGE LAST 30 DAYS',
    VIEW_IRN_CLICK : 'VIEW IRN DETAILS',

    // mis page
    MIS_PAGE:'MIS_PAGE',
    MIS_PAGE_CALENDAR :'MIS_PAGE CALENDAR',
    MIS_PAGE_EDIT_DURATION :'MIS_PAGE EDIT DURATION',
    MIS_PAGE_LAST7 :'MIS_PAGE LAST 7 DAYS',
    MIS_PAGE_LAST30 :'MIS_PAGE LAST 30 DAYS',
    VIEW_INVOICES_CLICK : 'VIEW INVOICES',

    // qr page
    QR_PAGE : 'QR_PAGE',
    GALLERY_ICON_CLICK :'GALLERY_ICON',
    SCAN_VALID : 'SCAN_VALID',
    QR_SHARE : 'SCANNED_INV_SHARE',
    QR_DOWNLOAD : 'SCANNED_INV_DOWNLOAD',
    SCAN_AGAIN : 'SCAN_AGAIN',
    SCAN_AGAIN_CLICK : 'SCAN_AGAIN_CLICK',

    // invoices page
    INVOICES_PAGE:'INVOICES_PAGE',
    INVOICES_PAGE_CALENDAR :'INVOICES_PAGE CALENDAR',
    INVOICES_PAGE_EDIT_DURATION :'INVOICES_PAGE EDIT DURATION',
    INVOICES_PAGE_LAST7 :'INVOICES_PAGE LAST 7 DAYS',
    INVOICES_PAGE_LAST30 :'INVOICES_PAGE LAST 30 DAYS',
    INVOICES_SHARE : 'INVOICE_SHARE',
    INVOICES_DOWNLOAD : 'INVOICE_DOWNLOAD',
    INVOICES_DOWNLOAD_SUCCESS : 'INVOICES_DOWNLOAD_SUCCESS',
    INVOICES_OKAY_CLICK : 'INVOICES_DOWNLOAD_SUCCESS OKAY',

    // alerts page
    ALERTS_PAGE:'ALERTS_PAGE',

    // side draw
    SIDE_DRAW : 'SIDE_DRAW',
    SWITCH_BUSINESS : 'SWITCH_BUSINESS',
    HELP_AND_SUPPORT : 'HELP_AND_SUPPORT',
    FEEDBACK : 'FEEDBACK',
    LOGOUT : 'LOGOUT',

    // bottom bar
    HOME : 'HOME',
    MIS : 'MIS',
    QR_CODE : 'QR_CODE',
    INVOICES : 'INVOICES',
    ALERTS : 'ALERTS',

    // business draw
    BUSINESS_DRAW : 'BUSINESS_DRAW',
    CHOOSE_BUSINESS : 'CHOOSE_BUSINESS',
    CLOSE_BUSINESS_DRAW : 'CLOSE_BUSINESS_DRAW',

    // logout draw
    LOGOUT_DRAW :'LOGOUT_DRAW',
    CONFIRM_LOGOUT : 'CONFIRM_LOGOUT',
    CANCEL_LOGOUT : 'CANCEL_LOGOUT',
    CLOSE_LOGOUT_DRAW : 'CLOSE_LOGOUT_DRAW',

    HAMBURGERGER : 'HAMBURGERGER',

    // feedback
    FEEDBACK_PAGE : 'FEEDBACK_PAGE',
    BAD : 'BAD',
    OKAY : 'OKAY',
    GREAT : 'GREAT',
    SEND_FEEDBACK : 'SEND_FEEDBACK',
    FEEDBACK_SUCCESS : 'FEEDBACK SUCCESS PAGE',
    FEEDBACK_OKAY : 'FEEDBACK SUCCESS OKAY_CLICK',
    CHOOSE_FEEDBK_OPTION : 'WHAT WENT WRONG OPTIONS',
}


export const EventIDs = {
    // intro page
    INTRO_PAGE: 'INTRO PAGE',
    SIGN_IN_CLICK : 'SIGN_IN',

    // home page
    HOME_PAGE:'HOME_PAGE',
    HOME_PAGE_TODAY : 'HOME_PAGE_TODAY',
    HOME_PAGE_LAST7 :'HOME_PAGE LAST 7 DAYS',
    HOME_PAGE_LAST30 :'HOME_PAGE LAST 30 DAYS',
    VIEW_IRN_CLICK : 'VIEW IRN DETAILS',

    // mis page
    MIS_PAGE:'MIS_PAGE',
    MIS_PAGE_CALENDAR :'MIS_PAGE CALENDAR',
    MIS_PAGE_EDIT_DURATION :'MIS_PAGE EDIT DURATION',
    MIS_PAGE_LAST7 :'MIS_PAGE LAST 7 DAYS',
    MIS_PAGE_LAST30 :'MIS_PAGE LAST 30 DAYS',
    VIEW_INVOICES_CLICK : 'VIEW INVOICES',

    // qr page
    QR_PAGE : 'QR_PAGE',
    GALLERY_ICON_CLICK :'GALLERY_ICON',
    SCAN_VALID : 'SCAN_VALID',
    QR_SHARE : 'SCANNED_INV_SHARE',
    QR_DOWNLOAD : 'SCANNED_INV_DOWNLOAD',
    SCAN_AGAIN : 'SCAN_AGAIN',
    SCAN_AGAIN_CLICK : 'SCAN_AGAIN_CLICK',

    // invoices page
    INVOICES_PAGE:'INVOICES_PAGE',
    INVOICES_PAGE_CALENDAR :'INVOICES_PAGE CALENDAR',
    INVOICES_PAGE_EDIT_DURATION :'INVOICES_PAGE EDIT DURATION',
    INVOICES_PAGE_LAST7 :'INVOICES_PAGE LAST 7 DAYS',
    INVOICES_PAGE_LAST30 :'INVOICES_PAGE LAST 30 DAYS',
    INVOICES_SHARE : 'INVOICE_SHARE',
    INVOICES_DOWNLOAD : 'INVOICE_DOWNLOAD',
    INVOICES_DOWNLOAD_SUCCESS : 'INVOICES_DOWNLOAD_SUCCESS',
    INVOICES_OKAY_CLICK : 'INVOICES_DOWNLOAD_SUCCESS OKAY',

    // alerts page
    ALERTS_PAGE:'ALERTS_PAGE',

    // side draw
    SIDE_DRAW : 'SIDE_DRAW',
    SWITCH_BUSINESS : 'SWITCH_BUSINESS',
    HELP_AND_SUPPORT : 'HELP_AND_SUPPORT',
    FEEDBACK : 'FEEDBACK',
    LOGOUT : 'LOGOUT',

    // bottom bar
    HOME : 'HOME',
    MIS : 'MIS',
    QR_CODE : 'QR_CODE',
    INVOICES : 'INVOICES',
    ALERTS : 'ALERTS',

    // business draw
    BUSINESS_DRAW : 'BUSINESS_DRAW',
    CHOOSE_BUSINESS : 'CHOOSE_BUSINESS',
    CLOSE_BUSINESS_DRAW : 'CLOSE_BUSINESS_DRAW',

    // logout draw
    LOGOUT_DRAW :'LOGOUT_DRAW',
    CONFIRM_LOGOUT : 'CONFIRM_LOGOUT',
    CANCEL_LOGOUT : 'CANCEL_LOGOUT',
    CLOSE_LOGOUT_DRAW : 'CLOSE_LOGOUT_DRAW',

    HAMBURGERGER : 'HAMBURGERGER',

    // feedback
    FEEDBACK_PAGE : 'FEEDBACK_PAGE',
    BAD : 'BAD',
    OKAY : 'OKAY',
    GREAT : 'GREAT',
    SEND_FEEDBACK : 'SEND_FEEDBACK',
    FEEDBACK_SUCCESS : 'FEEDBACK SUCCESS PAGE',
    FEEDBACK_OKAY : 'FEEDBACK SUCCESS OKAY_CLICK',
    CHOOSE_FEEDBK_OPTION : 'WHAT WENT WRONG OPTIONS',
}

export const events = {
    [EventIDs.INTRO_PAGE] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.INTRO,
        label : EventLabels.INTRO_PAGE,
    },
    [EventIDs.SIGN_IN_CLICK] : {
        action :  EventActions.CLICK,
        category : EventCategory.INTRO,
        label : EventLabels.SIGN_IN_CLICK,
    },
    [EventIDs.HOME_PAGE] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.HOME,
        label : EventLabels.HOME_PAGE,
    },
    [EventIDs.HOME_PAGE_TODAY] : {
        action :  EventActions.CLICK,
        category : EventCategory.HOME,
        label : EventLabels.HOME_PAGE_TODAY,
    },
    [EventIDs.HOME_PAGE_LAST7] : {
        action :  EventActions.CLICK,
        category : EventCategory.HOME,
        label : EventLabels.HOME_PAGE_LAST7,
    },
    [EventIDs.HOME_PAGE_LAST30] : {
        action :  EventActions.CLICK,
        category : EventCategory.HOME,
        label : EventLabels.HOME_PAGE_LAST30,
    },
    [EventIDs.VIEW_IRN_CLICK] : {
        action :  EventActions.CLICK,
        category : EventCategory.HOME,
        label : EventLabels.VIEW_IRN_CLICK,
    },
    [EventIDs.MIS_PAGE] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.MIS,
        label : EventLabels.MIS_PAGE,
    },
    [EventIDs.MIS_PAGE_CALENDAR] : {
        action :  EventActions.CLICK,
        category : EventCategory.MIS,
        label : EventLabels.MIS_PAGE_CALENDAR,
    },
    [EventIDs.MIS_PAGE_EDIT_DURATION] : {
        action :  EventActions.CLICK,
        category : EventCategory.MIS,
        label : EventLabels.MIS_PAGE_EDIT_DURATION,
    },
    [EventIDs.MIS_PAGE_LAST7] : {
        action :  EventActions.CLICK,
        category : EventCategory.MIS,
        label : EventLabels.MIS_PAGE_LAST7,
    },
    [EventIDs.MIS_PAGE_LAST30] : {
        action :  EventActions.CLICK,
        category : EventCategory.MIS,
        label : EventLabels.MIS_PAGE_LAST30,
    },
    [EventIDs.VIEW_INVOICES_CLICK] : {
        action :  EventActions.CLICK,
        category : EventCategory.MIS,
        label : EventLabels.VIEW_INVOICES_CLICK,
    },
    [EventIDs.QR_PAGE] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.QR_CODE,
        label : EventLabels.QR_PAGE,
    },
    [EventIDs.GALLERY_ICON_CLICK] : {
        action :  EventActions.CLICK,
        category : EventCategory.QR_CODE,
        label : EventLabels.GALLERY_ICON_CLICK,
    },
    [EventIDs.SCAN_VALID] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.QR_CODE,
        label : EventLabels.SCAN_VALID,
    },
    [EventIDs.QR_SHARE] : {
        action :  EventActions.CLICK,
        category : EventCategory.QR_CODE,
        label : EventLabels.QR_SHARE,
    },
    [EventIDs.QR_DOWNLOAD] : {
        action :  EventActions.CLICK,
        category : EventCategory.QR_CODE,
        label : EventLabels.QR_DOWNLOAD,
    },
    [EventIDs.SCAN_AGAIN] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.QR_CODE,
        label : EventLabels.SCAN_AGAIN,
    },
    [EventIDs.SCAN_AGAIN_CLICK] : {
        action :  EventActions.CLICK,
        category : EventCategory.QR_CODE,
        label : EventLabels.SCAN_AGAIN_CLICK,
    },
    [EventIDs.INVOICES_PAGE] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_PAGE,
    },
    [EventIDs.INVOICES_PAGE_CALENDAR] : {
        action :  EventActions.CLICK,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_PAGE_CALENDAR,
    },
    [EventIDs.INVOICES_PAGE_EDIT_DURATION] : {
        action :  EventActions.CLICK,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_PAGE_EDIT_DURATION,
    },
    [EventIDs.INVOICES_PAGE_LAST7] : {
        action :  EventActions.CLICK,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_PAGE_LAST7,
    },
    [EventIDs.INVOICES_PAGE_LAST30] : {
        action :  EventActions.CLICK,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_PAGE_LAST30,
    },
    [EventIDs.INVOICES_SHARE] : {
        action :  EventActions.CLICK,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_SHARE,
    },
    [EventIDs.INVOICES_DOWNLOAD] : {
        action :  EventActions.CLICK,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_DOWNLOAD,
    },
    [EventIDs.INVOICES_DOWNLOAD_SUCCESS] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_DOWNLOAD_SUCCESS,
    },
    [EventIDs.INVOICES_OKAY_CLICK] : {
        action :  EventActions.CLICK,
        category : EventCategory.INVOICES,
        label : EventLabels.INVOICES_OKAY_CLICK,
    },
    [EventIDs.ALERTS_PAGE] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.ALERTS,
        label : EventLabels.ALERTS_PAGE,
    },
    [EventIDs.SIDE_DRAW ] : {
        action :  EventActions.VIEW,
        category : EventCategory.SIDE_DRAW,
        label : EventLabels.SIDE_DRAW ,
    },
    [EventIDs.SWITCH_BUSINESS] : {
        action :  EventActions.CLICK,
        category : EventCategory.SIDE_DRAW,
        label : EventLabels.SWITCH_BUSINESS,
    },
    [EventIDs.HELP_AND_SUPPORT] : {
        action :  EventActions.CLICK,
        category : EventCategory.SIDE_DRAW,
        label : EventLabels.HELP_AND_SUPPORT,
    },
    [EventIDs.FEEDBACK] : {
        action :  EventActions.CLICK,
        category : EventCategory.SIDE_DRAW,
        label : EventLabels.FEEDBACK,
    },
    [EventIDs.FEEDBACK_PAGE] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.FEEDBACK,
        label : EventLabels.FEEDBACK_PAGE,
    },
    [EventIDs.OKAY] : {
        action :  EventActions.CLICK,
        category : EventCategory.FEEDBACK,
        label : EventLabels.OKAY,
    },
    [EventIDs.BAD] : {
        action :  EventActions.CLICK,
        category : EventCategory.FEEDBACK,
        label : EventLabels.BAD,
    },
    [EventIDs.GREAT] : {
        action :  EventActions.CLICK,
        category : EventCategory.FEEDBACK,
        label : EventLabels.GREAT,
    },
    [EventIDs.SEND_FEEDBACK] : {
        action :  EventActions.CLICK,
        category : EventCategory.FEEDBACK,
        label : EventLabels.SEND_FEEDBACK,
    },
    [EventIDs.CHOOSE_FEEDBK_OPTION] : {
        action :  EventActions.CLICK,
        category : EventCategory.FEEDBACK,
        label : EventLabels.CHOOSE_FEEDBK_OPTION,
    },
    [EventIDs.FEEDBACK_SUCCESS] : {
        action :  EventActions.PAGEVIEW,
        category : EventCategory.FEEDBACK,
        label : EventLabels.FEEDBACK_SUCCESS,
    },
    [EventIDs.FEEDBACK_OKAY] : {
        action :  EventActions.CLICK,
        category : EventCategory.FEEDBACK,
        label : EventLabels.FEEDBACK_OKAY,
    },
    [EventIDs.LOGOUT] : {
        action :  EventActions.CLICK,
        category : EventCategory.SIDE_DRAW,
        label : EventLabels.LOGOUT,
    },
    [EventIDs.HOME] : {
        action :  EventActions.CLICK,
        category : EventCategory.BOTTOM_NAV_BAR,
        label : EventLabels.HOME,
    },
    [EventIDs.MIS] : {
        action :  EventActions.CLICK,
        category : EventCategory.BOTTOM_NAV_BAR,
        label : EventLabels.MIS,
    },
    [EventIDs.QR_CODE] : {
        action :  EventActions.CLICK,
        category : EventCategory.BOTTOM_NAV_BAR,
        label : EventLabels.QR_CODE,
    },
    [EventIDs.INVOICES] : {
        action :  EventActions.CLICK,
        category : EventCategory.BOTTOM_NAV_BAR,
        label : EventLabels.INVOICES,
    },
    [EventIDs.ALERTS] : {
        action :  EventActions.CLICK,
        category : EventCategory.BOTTOM_NAV_BAR,
        label : EventLabels.ALERTS,
    },
    [EventIDs.BUSINESS_DRAW ] : {
        action :  EventActions.VIEW,
        category : EventCategory.BUSINESS_DRAW,
        label : EventLabels.BUSINESS_DRAW ,
    },
    [EventIDs.CHOOSE_BUSINESS] : {
        action :  EventActions.CLICK,
        category : EventCategory.BUSINESS_DRAW,
        label : EventLabels.CHOOSE_BUSINESS,
    },
    [EventIDs.CLOSE_BUSINESS_DRAW] : {
        action :  EventActions.CLICK,
        category : EventCategory.BUSINESS_DRAW,
        label : EventLabels.CLOSE_BUSINESS_DRAW,
    },
    [EventIDs.LOGOUT_DRAW ] : {
        action :  EventActions.VIEW,
        category : EventCategory.LOGOUT_DRAW,
        label : EventLabels.LOGOUT_DRAW ,
    },
    [EventIDs.CONFIRM_LOGOUT] : {
        action :  EventActions.CLICK,
        category : EventCategory.LOGOUT_DRAW,
        label : EventLabels.CONFIRM_LOGOUT,
    },
    [EventIDs.CANCEL_LOGOUT] : {
        action :  EventActions.CLICK,
        category : EventCategory.LOGOUT_DRAW,
        label : EventLabels.CANCEL_LOGOUT,
    },
    [EventIDs.CLOSE_LOGOUT_DRAW] : {
        action :  EventActions.CLICK,
        category : EventCategory.LOGOUT_DRAW,
        label : EventLabels.CLOSE_LOGOUT_DRAW,
    },
    [EventIDs.HAMBURGERGER] : {
        action :  EventActions.CLICK,
        category : EventCategory.COMPANION,
        label : EventLabels.HAMBURGERGER,
    },
}